
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news-detail/page'));
const ArticlesListPage = lazy(() => import('../pages/articles/page'));
const ArticleDetailPage = lazy(() => import('../pages/article-detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about.html',
    element: <AboutPage />,
  },
  {
    path: '/contact.html',
    element: <ContactPage />,
  },
  {
    path: '/news.html',
    element: <NewsPage />,
  },
  {
    path: '/news/:slug',
    element: <NewsDetailPage />,
  },
  {
    path: '/libraries/pgss/',
    element: <ArticlesListPage />,
  },
  {
    path: '/libraries/pgss/:slug',
    element: <ArticleDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
